import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import StatusBadge from 'components/atoms/status-badge'
import React from 'react'
import ToggleCheckBox from 'components/molecules/toggle-check-box/toggle-check-box'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const dataCellPropTypes = {
  cell: PropTypes.shape({
    value: PropTypes.any
  })
}

const ACTION_COMPONENT = {
  BUTTON : 'button',
  TOGGLE : 'toggle'
}

const productImageTableColumns = ({
  rowButtonProps,
  handleClickImage
}) => {

  const ImageCell = ({ cell: { value: image_source } }) => (
    <span
      onClick={ () => handleClickImage(image_source) }
    >
      <img
        width='150'
        src={ image_source }
        alt='product thumbnails'
      />
    </span>
  )

  ImageCell.propTypes = dataCellPropTypes

  const CoverCell = ({ cell: { value: isCover } }) => (
    isCover ? <StatusBadge color={ 'primary' } label={ 'Foto Utama' } /> : ''
  )

  CoverCell.propTypes = dataCellPropTypes

  const DefectCell = ({ cell: { value: isDefect } }) => (
    isDefect ? <StatusBadge color={ 'warning' } label={ 'Foto Defect' } /> : ''
  )

  DefectCell.propTypes = dataCellPropTypes

  const generateActionComponent = ({
    image,
    actionComponent
  }) => {
    const disabled = actionComponent.isDisabled ? actionComponent.isDisabled(image) : false

    switch (actionComponent.type) {
      case (ACTION_COMPONENT.BUTTON):
        return (
          <RowButton
            data={ image }
            color={ actionComponent.colour }
            disabled={ disabled }
            onClick={ actionComponent.onClick }
            text={ actionComponent.text }
          />
        )
      case (ACTION_COMPONENT.TOGGLE):
        return (
          <ToggleCheckBox
            data = { image }
            value={ image.is_defect }
            onChange={ actionComponent.onClick }
          />
        )
      default:
        return (
          <RowButton
            data={ image }
            color={ actionComponent.colour }
            disabled={ disabled }
            onClick={ actionComponent.onClick }
            text={ actionComponent.text }
          />
        )
    }
  }

  const generateActionCell = () => {

    const actionComponents = rowButtonProps.map((actionComponent) => {

      const ActionCell = ({ cell: { row } }) => {
        const image = row.original
        return (
          <>
            {
              generateActionComponent({
                image,
                actionComponent
              })
            }
          </>
        )

      }

      ActionCell.propTypes = actionCellPropTypes

      return {
        id   : actionComponent.id,
        Cell : ActionCell
      }
    })

    return actionComponents
  }

  return (
    [
      {
        Header  : 'Product Images',
        columns : [
          {
            Header         : 'Foto',
            accessor       : 's3_url',
            disableFilters : true,
            Cell           : ImageCell
          },
          {
            Header         : 'Gambar Defect',
            accessor       : 'is_defect',
            disableFilters : true,
            Cell           : DefectCell
          },
          {
            Header         : 'Gambar Utama',
            accessor       : 'is_cover',
            disableFilters : true,
            Cell           : CoverCell
          }
        ]
      },
      {
        Header  : 'Actions',
        columns : [
          // * Generate action cell with buttonProps
          ...generateActionCell()
        ]
      }
    ]
  )
}

export default productImageTableColumns
